import React, { useState, useEffect, useMemo } from "react";
import { Formik, Form, FormikHelpers } from "formik";
import * as Yup from "yup";

//MUI
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";

import FormikControl from "../../components/formik/FormikControl";
import Loader from "../../components/loader/Loader";

import SegmentBUMapService from "../../services/SegmentBUMapService";
import { Mode } from "./SegmentBUMapPage";
import { SegmentBUMapModel } from "../../models/SegmentBUMapModel";
// import { statusOptions } from "../../utility/utils";
import { fetchSegmentBUMaps } from "../../redux/actions/SegmentBUMapActions";
import { useAppDispatch, useAppSelector } from "../../redux/hooks/redux-hooks";
import { createAutocompleteOptions } from "../../utility/utils";
import ConfirmDialog from "../ConfirmDialog";

const validationSchema = Yup.object({
  segmentId: Yup.number().min(1, "Required").required("Required"),
  bUId: Yup.number().min(1, "Required").required("Required"),
  // status: Yup.string().required("Required"),
});

type FormProps = Yup.InferType<typeof validationSchema>;

type Props = {
  mode: Mode;
  handleModalClose: () => void;
  data?: SegmentBUMapModel;
};

const SegmentBuMapForm = ({ mode, handleModalClose, data }: Props) => {
  const initialValues = useMemo(
    () => ({
      segmentId: 0,
      bUId: 0,
      // status: "",
    }),
    []
  );

  const [formState, setFormState] = useState<FormProps>(initialValues);
  const dispatch = useAppDispatch();
  const displayToast = useAppSelector((state) => state.toast.displayToast);
  const allSegemntLOBs = useAppSelector(
    (state) => state.segmentLOB.all_SegmentLOBs
  );
  const allBUs = useAppSelector((state) => state.bu.all_BUs);

  const SegmentOptions = useMemo(() => {
    return createAutocompleteOptions(allSegemntLOBs, "segmentlobid", "name");
  }, [allSegemntLOBs]);

  const BUOptions = useMemo(() => {
    return createAutocompleteOptions(allBUs, "buid", "name");
  }, [allBUs]);

  useEffect(() => {
    if (mode === "delete" && data) {
      setFormState(() => ({
        segmentId: data.segmentId,
        bUId: data.buid,
        // status: data.isActive ? "active" : "inactive",
      }));
    }
  }, [mode, data]);

  const submitHandler = async (
    values: FormProps,
    actions: FormikHelpers<FormProps>
  ) => {
    try {
      let formData: SegmentBUMapModel = {
        segmentId: 0,
        buid: 0,
        isActive: true,
      };
      if (mode === "add") {
        formData.segmentId = values.segmentId;
        formData.buid = values.bUId;
        // formData.isActive = values.status === "active" ? true : false;
      } else if (data) {
        formData = {
          ...data,
          segmentId: values.segmentId,
          buid: values.bUId,
          // isActive: values.status === "active" ? true : false,
        };
      }
      mode === "delete"
        ? await SegmentBUMapService.deleteSegmentBUMap(formData)
        : await SegmentBUMapService.createSegmentBUMap(formData);
      actions.setSubmitting(false);
      handleModalClose();
      dispatch(fetchSegmentBUMaps());
      displayToast(
        `Segment-BU mapping ${
          mode === "add" ? "created" : "deleted"
        } successfully`,
        "success"
      );
    } catch (error) {
      actions.setSubmitting(false);
    }
  };
  return (
    <Formik
      initialValues={formState}
      validationSchema={validationSchema}
      onSubmit={submitHandler}
      enableReinitialize={true}
    >
      {(formik) => (
        <>
          <Form>
            {mode === "delete" ? (
              <ConfirmDialog handleModalClose={handleModalClose} />
            ) : (
              <Stack gap={2}>
                <FormikControl
                  control="autocomplete"
                  options={SegmentOptions}
                  name="segmentId"
                  size="small"
                  label="Segemnt"
                  placeholder="Select Segment"
                />
                <FormikControl
                  control="autocomplete"
                  options={BUOptions}
                  name="bUId"
                  size="small"
                  label="BU"
                  placeholder="Select BU"
                />
                {/* <FormikControl
                  control="autocomplete"
                  options={statusOptions}
                  name="status"
                  size="small"
                  label="Status"
                  placeholder="Select Status"
                /> */}
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={formik.isSubmitting}
                >
                  Submit
                </Button>
              </Stack>
            )}
          </Form>
          {formik.isSubmitting && <Loader />}
        </>
      )}
    </Formik>
  );
};

export default SegmentBuMapForm;
